// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../web-ai-translation/node_modules/css-loader/index.js??ref--8-oneOf-3-1!../../../../../web-ai-translation/node_modules/postcss-loader/src/index.js??ref--8-oneOf-3-2!../../../../../web-ai-translation/node_modules/sass-loader/dist/cjs.js??ref--8-oneOf-3-3!./_theme.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../web-ai-translation/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("22a055c3", content, true, {"sourceMap":false,"shadowMode":false});